import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsCycleTimePercentileTrendPoint } from "@/http/api-types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { EmptyState } from "./empty-state";
import { secondsToDays } from "./formatters";

export function CycleTimePercentileTrendChart({ data }: { data: JiraMetricsCycleTimePercentileTrendPoint[] }) {
  const chartData = data.map(point => ({
    period: point.period,
    p25: secondsToDays(point.p25),
    p50: secondsToDays(point.p50),
    p75: secondsToDays(point.p75),
    min: secondsToDays(point.min),
    max: secondsToDays(point.max),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cycle Time Percentile Trend (P25/P50/P75)</CardTitle>
        <CardDescription>
          P50 is the median cycle time; P25/P75 show the middle spread. Large gaps indicate unstable delivery time.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {chartData.length === 0 ? (
          <EmptyState message="No completed tickets in selected range." />
        ) : (
          <ChartContainer
            className="h-72 w-full"
            config={{
              p25: { label: "P25", color: "#a855f7" },
              p50: { label: "P50", color: "#0ea5e9" },
              p75: { label: "P75", color: "#f97316" },
            }}
          >
            <LineChart data={chartData}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="period" />
              <YAxis />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Line type="monotone" dataKey="p25" stroke="var(--color-p25)" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="p50" stroke="var(--color-p50)" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="p75" stroke="var(--color-p75)" strokeWidth={2} dot={false} />
            </LineChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
